<template>
  <div class="t-lk-leads">
    <div class="t-lk-leads__filter">
      <label class="t-lk-leads__filter-item">
        {{ leadStatus.label }}

        <lk-select-cmp :value="leadStatus.value" :options="leadStatus.options" @update:value="v => (leadStatus.value = v)" />
      </label>

      <label v-if="filter" class="t-lk-leads__filter-item">
        {{ leadVendor.label }}

        <lk-select-cmp
          :values="leadVendor.values"
          :options="leadVendor.options"
          :multiple="true"
          @update:values="v => (leadVendor.values = v)"
        />
      </label>
    </div>
    <transition-group tag="div" class="t-lk-leads__leads" :name="leadsView === 'list' ? 'fadeLeadsLeft' : 'fadeLeadsRight'">
      <template v-if="leadsToShow.length">
        <transition-group tag="div" v-if="leadsView === 'list'" class="t-lk-leads__list" name="fadecLeadsChange" key="list">
          <lk-lead-list-item-cmp v-for="(item, index) in leadsToShow" :item="item" :key="`list-${leadStatus.value}-${index}`" />
        </transition-group>

        <transition-group tag="div" name="fadecLeadsChange" v-else-if="leadsView === 'tile'" class="t-lk-leads__tiles" key="tile">
          <lk-lead-tile-item-cmp v-for="(item, index) in leadsToShow" :item="item" :key="`tile-${leadStatus.value}-${index}`" />
        </transition-group>
      </template>

      <div v-else name="fadecLeadsChange" class="t-lk-leads__not-found" key="not-found">
        Ничего не найдено
      </div>
    </transition-group>
  </div>
</template>

<script>
import lkLeadsSelect from '@components/lk/lk-leads-select/lk-leads-select.vue'
import lkDate from '@components/lk/lk-date-lead/lk-date-lead.vue'
import lkLeadTileItem from './lk-lead-tile-item.vue'
import lkLeadListItem from './lk-lead-list-item.vue'

export default {
  name: 'lk-leads-list',
  props: {
    leads: {
      type: Array,
      default: () => [],
    },
    filter: {
      type: Object,
      default: null,
    },
    reasons: {
      type: Array,
      default: () => [],
    },
    leadsView: {
      type: String,
      default: 'tile',
      validator: value => ['tile', 'list'].includes(value),
    },
  },
  computed: {
    leadsToShow() {
      const availableLeadsByVendor = this.leads.filter(lead =>
        this.leadVendor.values.length ? this.leadVendor.values.includes(lead.vendor.toString()) : true
      )

      switch (this.leadStatus.value) {
        case 'new':
          return availableLeadsByVendor.filter(lead => lead.status === 0)
        case 'work':
          return availableLeadsByVendor.filter(lead => lead.status !== 0)
        default:
          return availableLeadsByVendor
      }
    },
  },
  components: {
    'lk-date-lead-cmp': lkDate,
    'lk-lead-tile-item-cmp': lkLeadTileItem,
    'lk-lead-list-item-cmp': lkLeadListItem,
    'lk-select-cmp': lkLeadsSelect,
  },
  data() {
    return {
      leadStatus: {
        value: 'all',
        label: 'Выбрать статус',
        options: {
          all: 'Все',
          new: 'Новые',
          work: 'В работе',
        },
      },
      leadVendor: {
        values: [],
        label: 'Выбрать вендора',
        options: this.filter?.vendor,
      },
    }
  },
}
</script>

<style lang="sass">
.t-lk-leads__filter
    display: flex
    flex-direction: row
    margin-block-start: 16px

.t-lk-leads__filter-item
    display: flex
    flex-direction: column
    flex: 1
    gap: 8px

@media screen and (max-width: 920px)
    .t-lk-leads__filter
        padding-inline: 8px
</style>



// WEBPACK FOOTER //
// src/templates/components/lk/lk-leads-list/lk-leads-list.vue